<template>
    <div>
      <!-- Nav tabs -->
      <nav class="navbar navbar--primary navbar-expand-xl">
        <button class="nav-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navTabCollapse" aria-controls="navTabCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <span class="nav-toggler__title">{{ activeTab ? activeTab.title : '' }}</span>
        </button>
        <ul class="nav nav--primary" id="navTabCollapse" role="tablist">
          <li v-for="(tab, index) in tabs" :key="index" class="nav-item" :role="tab.role || 'tab'">
            <button 
              class="nav-link" 
              :class="{ 'active': tab.id === activeTabId }"
              :id="`${tab.id}-tab`" 
              data-bs-toggle="tab" 
              :data-bs-target="`#${tab.id}`" 
              type="button" 
              role="tab" 
              :aria-controls="tab.id" 
              :aria-selected="tab.id === activeTabId ? 'true' : 'false'"
              @click="handleTabClick(tab)"
              :disabled="tab.disabled"
            > 
              {{ tab.title }}
            </button>
          </li>
        </ul>
      </nav>
                  
      <!-- Tab panes -->
      <div class="tab-content" id="myTabContent">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, onMounted, nextTick, computed, provide } from 'vue';
  
  const props = defineProps({
    tabs: {
      type: Array,
      required: true
    },
    initialTabId: {
      type: String,
      default: ''
    },
    modelValue: String, 
  });

  const emit = defineEmits(['update:modelValue'])
  
  const activeTabId = ref(props.initialTabId || (props.tabs.length > 0 ? props.tabs[0].id : ''));
  
  const activeTab = computed(() => {
    return props.tabs.find(tab => tab.id === activeTabId.value) || null;
  });

  watch(() => props.modelValue, (newVal) => {
  if (newVal && newVal !== activeTabId.value) {
    activeTabId.value = newVal;
  }
})
  
  const handleTabClick = (tab) => {
    activeTabId.value = tab.id;
    
    if (process.client && window.innerWidth < 1200) {
      nextTick(() => {
        const collapseToggler = document.querySelector('[data-bs-target="#navTabCollapse"]');
        if (collapseToggler) {
          collapseToggler.click();
        } else {
          const navCollapse = document.getElementById('navTabCollapse');
          if (navCollapse) {
            navCollapse.classList.remove('show');
          }
        }
      });
    }
  };
  
  provide('activeTabId', activeTabId);
  
  onMounted(() => {
    console.log('TabPrimary component mounted');
    
    if (!props.initialTabId && props.tabs.length > 0 && !props.modelValue) {
      activeTabId.value = props.tabs[0].id;
      emit('update:modelValue', activeTabId.value);
    }
  });
  </script>